import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import Loadable from '@/components/Loadable'

const Templates = Loadable(
  lazy(
    () => import('../pages/MedicalRecordTemplates/MedicalRecordTemplates.page'),
  ),
  true,
)

const TemplateStepper = Loadable(
  lazy(
    () =>
      import(
        '../pages/MedicalRecordTemplates/components/TemplateStepper/TemplateStepper.component'
      ),
  ),
  true,
)

const MedicalRecordTemplatesRoutes: RouteObject = {
  children: [
    {
      path: 'templates-prontuario',
      element: <Templates />,
    },
    { path: 'templates-prontuario/novo', element: <TemplateStepper /> },
    {
      path: 'templates-prontuario/editar/:templateId',
      element: <TemplateStepper />,
    },
  ],
}

export default MedicalRecordTemplatesRoutes
